import { useState } from "react";
import {
  Layout,
  Menu,
  Typography,
  Avatar,
  Dropdown,
  Space,
  Button,
  theme
} from "antd";
import {
  HomeOutlined,
  FileTextOutlined,
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  MedicineBoxOutlined,
  ClockCircleOutlined,
  ContactsOutlined
} from "@ant-design/icons";

import logo from "../../assets/logo.png";
import Newsform from "../Forms/Newsform";
import AddServices from "../Forms/AddServices";
import StaffManagement from "../StaffManagement/StaffManagement";
import DoctorManagement from "../Forms/DoctorManagement";
import ClinicHoursManagement from "../Forms/ClinicHoursManagement";
import ContactInfoManagement from "../Forms/ContactInfoManagement";
import "./admincss.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const Adminforms = () => {
  const [selectedForm, setSelectedForm] = useState("news");
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleLogout = () => {
    Cookies.remove("jwtToken");
    navigate('/');
  };

  const menuItems = [
    {
      key: "news",
      icon: <FileTextOutlined />,
      label: "Neuigkeiten",
    },
    {
      key: "service",
      icon: <SettingOutlined />,
      label: "Leistungen",
    },
    {
      key: "staff",
      icon: <TeamOutlined />,
      label: "Personal",
    },
    {
      key: "doctors",
      icon: <MedicineBoxOutlined />,
      label: "Ärzte",
    },
    {
      key: "hours",
      icon: <ClockCircleOutlined />,
      label: "Sprechzeiten",
    },
    {
      key: "contact",
      icon: <ContactsOutlined />,
      label: "Kontakt",
    },
  ];

  const userMenuItems = [
    {
      key: "profile",
      icon: <UserOutlined />,
      label: "Profil",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Abmelden",
      onClick: handleLogout,
    },
  ];

  const renderContent = () => {
    switch (selectedForm) {
      case "news":
        return <Newsform />;
      case "service":
        return <AddServices />;
      case "staff":
        return <StaffManagement />;
      case "doctors":
        return <DoctorManagement />;
      case "hours":
        return <ClinicHoursManagement />;
      case "contact":
        return <ContactInfoManagement />;
      default:
        return <Newsform />;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          background: colorBgContainer,
          boxShadow: "2px 0 8px 0 rgba(29,35,41,.05)",
        }}
      >
        <div
          style={{
            height: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              height: 32,
              marginRight: collapsed ? 0 : 8,
            }}
          />
          {!collapsed && (
            <Title level={5} style={{ margin: 0, color: "#41b06e" }}>
              Praxis am Ring
            </Title>
          )}
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedForm]}
          items={menuItems}
          onClick={({ key }) => setSelectedForm(key)}
          style={{
            borderRight: 0,
            marginTop: 16,
          }}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: "0 24px",
            background: colorBgContainer,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 1px 4px rgba(0,21,41,.08)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              type="text"
              icon={collapsed ? <HomeOutlined /> : <HomeOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />
            <Title level={4} style={{ margin: 0, marginLeft: 16 }}>
              {selectedForm === "news" && "Neuigkeiten"}
              {selectedForm === "service" && "Leistungen"}
              {selectedForm === "staff" && "Personalverwaltung"}
              {selectedForm === "doctors" && "Ärzteverwaltung"}
              {selectedForm === "hours" && "Sprechzeiten"}
              {selectedForm === "contact" && "Kontaktinformationen"}
            </Title>
          </div>
          <Dropdown
            menu={{
              items: userMenuItems,
            }}
            placement="bottomRight"
          >
            <Space style={{ cursor: "pointer" }}>
              <Avatar icon={<UserOutlined />} />
              <span>Administrator</span>
            </Space>
          </Dropdown>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Adminforms;
